module.exports = __webpack_public_path__ + "img/preguntas_inversionista.0b3e8810.webp";